import * as React from 'react';
import type { SVGProps } from 'react';

const IconCopyLink = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 16" {...props}>
    <path
      d="M4.834 15.6a3.91 3.91 0 0 1-2.776-1.146 3.933 3.933 0 0 1 0-5.552l2.605-2.605a.756.756 0 1 1 1.069 1.069L3.127 9.97a2.416 2.416 0 0 0 0 3.414c.936.934 2.472.94 3.414 0l2.605-2.605a.756.756 0 1 1 1.07 1.07L7.61 14.454A3.915 3.915 0 0 1 4.834 15.6ZM11.798 9.93a.756.756 0 0 1-.534-1.291l2.605-2.608a2.398 2.398 0 0 0 .709-1.707c0-.644-.251-1.253-.71-1.708a2.415 2.415 0 0 0-3.414 0L7.85 5.224a.756.756 0 1 1-1.07-1.069l2.605-2.608a3.933 3.933 0 0 1 5.553 0 3.904 3.904 0 0 1 1.152 2.776c0 1.049-.41 2.035-1.152 2.777l-2.605 2.608a.75.75 0 0 1-.534.221Z"
      fill="currentColor"
    />
    <path
      d="M6.267 11.014a.756.756 0 0 1-.537-1.288l4.462-4.513a.756.756 0 1 1 1.075 1.063L6.805 10.79a.749.749 0 0 1-.538.225Z"
      fill="currentColor"
    />
  </svg>
);
export default IconCopyLink;
